import { number, object, string } from "../../../types/_types";

export const CloudRevenueReport = object({
	bucket: string(),
	fullPath: string(),
	name: string(),
	url: string(),
});

// Whether it bills LIVE or INACTIVE works is the cost's price type.
export const CloudRevenueMeta = object({
	// "YYYY-MM"
	period: string(),
	works: number(),
	report: CloudRevenueReport,
});
